module.exports = __webpack_public_path__ + "assets/img/btn-detail-622e201a.png";